import React from 'react';
import DiagnosisChart from '../Common/WellDiagnosisChart';
import { mapXYArrays } from '../../../utilities/DiagnosisHelper';

interface DetailedPumpCurveChartProps {
  chartData: any;
  parameter: any;
  widgetHeader?: string;
}

const DetailedPumpCurveChart: React.FC<DetailedPumpCurveChartProps> = ({ chartData, parameter, widgetHeader }) => {
  const keys = parameter.map((cfg: any) => cfg.key);
  const formattedData = mapXYArrays(chartData, keys);

  return (
    <DiagnosisChart
      chartData={formattedData}
      seriesConfig={parameter}
      widgetHeader={chartData?.ChartTitle || widgetHeader}
      yAxisLabel='Total head (ft)'
      xAxisLabel='Average pump flowrate (rb/day)'
    />
  );
};

export default DetailedPumpCurveChart;
